var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "email-consult-editor",
      on: {
        dragover: function($event) {
          $event.preventDefault()
          return _vm.handleDragOver($event)
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "email-consult-editor__wrapper" },
        [
          _c("CompassAvatar", {
            attrs: {
              size: "small",
              initials: _vm.currentUserInitials,
              avatarColorType: _vm.avatarColor(_vm.currentUserFullName)
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "email-consult-editor__panel" },
            [
              _c(
                "div",
                { staticClass: "email-consult-editor__panel-header" },
                [
                  _c("EmailRecipientsInputs", {
                    staticClass: "email-recipients-inputs",
                    attrs: {
                      hashPanel: _vm.hashPanel,
                      recipients: _vm.recipients
                    },
                    on: { updateAddressesEmails: _vm.onUpdateAddressesEmails }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "email-consult-editor__panel-subject" },
                [
                  _c("EmailSubjectInput", {
                    attrs: { subject: _vm.email.subject },
                    on: {
                      "update:subject": function(newSubject) {
                        _vm.email.subject = newSubject
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.isLinkedObjectExist
                ? _c("EmailRelatedObject", {
                    attrs: { object: _vm.thread[0].linked_object }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("RichText", {
                ref: "refEmailPanelRichText",
                staticClass: "email-richtext",
                attrs: {
                  options: _vm.optionsRichText,
                  isCustom: true,
                  showRichTextMenu: false,
                  showAIComponents: _vm.showAIComponents,
                  typeRichText: "email",
                  hash: _vm.hash
                },
                on: {
                  focus: function($event) {
                    _vm.isEditorFocused = true
                  },
                  blur: function($event) {
                    _vm.isEditorFocused = false
                  }
                },
                scopedSlots: _vm._u(
                  [
                    _vm.isDragging
                      ? {
                          key: "drag-handle",
                          fn: function() {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "drag-text typographies-paragraph-large-bold",
                                  on: {
                                    dragleave: function($event) {
                                      $event.stopPropagation()
                                      return _vm.handleDragLeave($event)
                                    },
                                    drop: function($event) {
                                      $event.preventDefault()
                                      return _vm.handleDrop($event)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.labelDrag) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ]
                          },
                          proxy: true
                        }
                      : null
                  ],
                  null,
                  true
                ),
                model: {
                  value: _vm.email.content,
                  callback: function($$v) {
                    _vm.$set(_vm.email, "content", $$v)
                  },
                  expression: "email.content"
                }
              }),
              _vm._v(" "),
              _vm.expanded && !_vm.forward && !_vm.sending_type
                ? [
                    _c(
                      "CompassTooltip",
                      {
                        attrs: {
                          content: _vm.$t.__(
                            "email.EmailConsultPanelEditor.display_conversation"
                          ),
                          placement: "right"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "conversation-action",
                            on: { click: _vm.expandReplyText }
                          },
                          _vm._l(3, function(dot) {
                            return _c("span", { key: dot, staticClass: "dot" })
                          }),
                          0
                        )
                      ]
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.attachments.length
                ? _vm._l(_vm.attachments, function(item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "attachments-wrapper" },
                      [
                        _c("EmailAttachments", {
                          attrs: { canBeDownloaded: "", attachment: item },
                          on: { removeItem: _vm.removeAttachment }
                        })
                      ],
                      1
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.richTextEditor
                ? _c("RichTextMenu", {
                    staticClass: "email-richtext-menu",
                    attrs: {
                      editorMenu: _vm.richTextEditor,
                      options: _vm.optionsRichText,
                      typeRichText: "email",
                      disabled: _vm.isPanelMinimized,
                      hash: _vm.hash
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "actions",
                          fn: function() {
                            return [
                              !_vm.isReceivedTable && !_vm.isSentTable
                                ? _c("EmailCustomTemplateToolbar", {
                                    attrs: {
                                      hashPanel: _vm.hashPanel,
                                      typePanel: "consultPanel"
                                    }
                                  })
                                : _vm._e()
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      875835425
                    )
                  })
                : _vm._e()
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "email-consult-editor__footer" }, [
        _vm.showHint
          ? _c("div", {
              staticClass:
                "email-consult-editor__ai-hint typographies-paragraph-small-regular",
              domProps: { innerHTML: _vm._s(_vm.$t.__("richtext.ai.hint")) }
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "email-consult-editor__actions" },
          [
            _c("CompassButton", {
              attrs: {
                label: _vm.$t.__("common.actions.delete"),
                type: "secondary"
              },
              on: { click: _vm.handleDelete }
            }),
            _vm._v(" "),
            _vm.isFeatureScheduleEmailEnabled
              ? [
                  _c("CompassSplitButton", {
                    ref: "SplitSendButton",
                    attrs: {
                      label: _vm.$t.__("common.actions.send"),
                      loading: _vm.isLoading
                    },
                    on: {
                      clickOnLabel: _vm.sendEmail,
                      clickOnArrow: function($event) {
                        _vm.showDropdown = !_vm.showDropdown
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "CompassDropdown",
                    {
                      attrs: {
                        parentRef: "SplitSendButton",
                        isVisible: _vm.showDropdown,
                        placement: "top-end",
                        dropdownClass: "email-panel__schedule-dropdown"
                      },
                      on: {
                        onVisibilityChanged: function(visibility) {
                          return _vm.handleVisibleChange(visibility)
                        },
                        itemSelected: _vm.openScheduleEmail
                      }
                    },
                    [
                      _c("CompassDropdownOption", {
                        attrs: {
                          label: _vm.$t.__("email.ScheduleEmailDialog.title"),
                          value: "scheduleAction",
                          icon: "calendar-reschedule",
                          isCheckable: false
                        },
                        on: { click: _vm.openScheduleEmail }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("ScheduleEmailDialog", {
                    attrs: { visible: _vm.showScheduleEmailDialog },
                    on: {
                      scheduled: _vm.handleSendScheduledEmail,
                      close: function($event) {
                        _vm.showScheduleEmailDialog = false
                      }
                    }
                  })
                ]
              : _c("CompassButton", {
                  attrs: {
                    label: _vm.$t.__("common.actions.send"),
                    loading: _vm.isLoading
                  },
                  on: { click: _vm.sendEmail }
                })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "CompassDialog",
        {
          attrs: {
            visible: _vm.shouldDisplayErrorDialog,
            size: "small",
            title: _vm.$t.__("email.emailPanels.EmailPanel.error"),
            primaryAction: _vm.primaryAction,
            secondaryActions: _vm.secondaryActions
          },
          on: {
            "update:visible": function($event) {
              _vm.shouldDisplayErrorDialog = $event
            }
          }
        },
        [
          _c("div", { staticClass: "typographies-paragraph-medium-regular" }, [
            _vm._v(
              "\n            " + _vm._s(_vm.textDialogError) + "\n        "
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "CompassDialog",
        {
          attrs: {
            visible: _vm.shouldDisplayEmptyRecipientsWarningDialog,
            title: _vm.$t.__(
              "email.emailPanels.EmailPanel.empty_recipients_warning_dialog.title"
            ),
            size: "small",
            primaryAction: _vm.primaryActionEmptyRecipientsWarningDialog,
            secondaryActions: _vm.secondaryActionsEmptyRecipientsWarningDialog
          },
          on: {
            "update:visible": function($event) {
              _vm.shouldDisplayEmptyRecipientsWarningDialog = $event
            }
          }
        },
        [
          _c("p", {
            staticClass: "typographies-paragraph-medium-regular",
            domProps: {
              innerHTML: _vm._s(_vm.emptyRecipientsWarningDialogText)
            }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }